module.exports = __webpack_public_path__ + "media/src/images/user/default_avatars/default_avatar_16-53d351a035e6d8dd2f0154678f182574.png";